import type { ReferenceCategory, ReferenceValue } from '@parinaam-vms/shared';
import { apiGet, toQueryString } from './client';

export type ReferenceValuesByCategory = Record<string, ReferenceValue[]>;

/** All active values, or one category's worth (Plan D5). */
export function fetchReferenceValues(category?: ReferenceCategory): Promise<ReferenceValue[]> {
  return apiGet<ReferenceValue[]>(`/reference-values${toQueryString({ category })}`);
}

/**
 * Every category in one request. Forms need four dropdowns populated before they
 * can render; fetching them individually would mean four round trips and four
 * separate loading states.
 */
export function fetchReferenceValuesGrouped(): Promise<ReferenceValuesByCategory> {
  return apiGet<ReferenceValuesByCategory>('/reference-values?grouped=true');
}
